module.exports = "/assets/landing-dw/how-it-works/arrow.png?J3wBr5W";